(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crumb-crew-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const marquees = document.querySelectorAll('[data-crumb-marquee]');
    const reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    marquees.forEach((marquee) => {
      const track = marquee.querySelector('[data-crumb-track]');
      if (!track) return;

      const durationAttr = parseFloat(
        getComputedStyle(marquee).getPropertyValue('--crumb-duration')
      );
      const duration = isFinite(durationAttr) && durationAttr > 0 ? durationAttr : 60;

      let halfWidth = track.scrollWidth / 2;
      const measure = () => {
        halfWidth = track.scrollWidth / 2;
      };
      window.addEventListener('resize', measure);
      if (window.ResizeObserver) {
        new ResizeObserver(measure).observe(track);
      }

      let lastTime = null;
      let paused = reduceMotion;
      let resumeTimer = null;
      const RESUME_DELAY = 1800;

      const pause = () => {
        paused = true;
        if (resumeTimer) {
          clearTimeout(resumeTimer);
          resumeTimer = null;
        }
      };

      const scheduleResume = () => {
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(() => {
          paused = false;
          lastTime = null;
        }, RESUME_DELAY);
      };

      const onUserInteract = () => {
        pause();
        scheduleResume();
      };

      // Hover / focus pauses while user is reading
      marquee.addEventListener('mouseenter', pause);
      marquee.addEventListener('mouseleave', scheduleResume);
      marquee.addEventListener('focusin', pause);
      marquee.addEventListener('focusout', scheduleResume);

      // Active scroll input — touch swipe, trackpad/wheel, drag — pauses too
      marquee.addEventListener('pointerdown', onUserInteract, { passive: true });
      marquee.addEventListener('touchstart', onUserInteract, { passive: true });
      marquee.addEventListener('touchmove', onUserInteract, { passive: true });
      marquee.addEventListener('wheel', onUserInteract, { passive: true });
      marquee.addEventListener('keydown', onUserInteract);

      // Pause when offscreen so we don't burn cycles
      let visible = true;
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              visible = e.isIntersecting;
            });
          },
          { threshold: 0 }
        );
        io.observe(marquee);
      }

      const tick = (now) => {
        requestAnimationFrame(tick);
        if (!visible || paused || halfWidth <= 0) {
          lastTime = now;
          return;
        }
        if (lastTime == null) {
          lastTime = now;
          return;
        }
        const dt = (now - lastTime) / 1000;
        lastTime = now;
        const pxPerSec = halfWidth / duration;
        let next = marquee.scrollLeft + pxPerSec * dt;
        if (next >= halfWidth) next -= halfWidth;
        marquee.scrollLeft = next;
      };
      requestAnimationFrame(tick);

      // Seamlessly wrap when the user scrolls past the end of the first set
      marquee.addEventListener(
        'scroll',
        () => {
          if (halfWidth <= 0) return;
          if (marquee.scrollLeft >= halfWidth) {
            marquee.scrollLeft -= halfWidth;
          }
        },
        { passive: true }
      );
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
